<template>
  <div>
    <ConfirmDialog
      v-for="dialog in $confirm.value"
      v-model="$confirm.value"
      :key="dialog.id"
      :options="dialog"
    />
  </div>
</template>
<script setup lang="ts">
import { getCurrentInstance } from 'vue'
import ConfirmDialog from '@/components/globals/ConfirmDialog.vue'
const { $confirm } = getCurrentInstance().appContext.config.globalProperties
</script>
